const enlargeButton = document.querySelector(".js-enlarge-map");

if (enlargeButton) {
	enlargeButton.addEventListener("click", () => {
		enlargeButton.parentElement.classList.toggle("enlarged");
	});
}
